import styled from 'styled-components';
import media from '../../../styles/media.style';

import {
  WHITE,
  BG_GRAY,
  BLACK,
  STYLIST_LOCKUP,
  NAVIGATION_MOBILE_HEIGHT,
  NAVIGATION_DESKTOP_HEIGHT,
} from '../../../styles/variables.style';

export const CurrentPage = styled.span`
  text-transform: uppercase;
  text-decoration: underline;
  margin-right: 20px;

  ${media.tabletP`
    float: right;
  `};
`;

export const NextPage = styled.span`
  text-transform: uppercase;

  ${media.tabletP`
    float: right;
  `};
`;

export const Wrapper = styled.div`
  flex-grow: 1;
  margin-top: ${NAVIGATION_MOBILE_HEIGHT}px;

  ${media.tabletP`
    margin-top: ${NAVIGATION_DESKTOP_HEIGHT}px;
  `};
`;

export const DateSubtitle = styled.p`
  color: #9b9b9b;
  font-size: 12px;
  margin-bottom: 0;
`;

export const PhotoWidgetWrapper = styled.div`
  background-color: ${BLACK};
  color: ${WHITE};
  padding: 50px 16px 0;

  ${media.tabletL`
    padding: 95px 0 0;
  `};
`;

export const PhotoWidgetWrapperInner = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: ${STYLIST_LOCKUP}px;
`;

export const SectionTitle = styled.h2`
  text-transform: uppercase;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 1px;
  flex: 1;
  margin: 0;
`;

export const Title = styled.h3`
  text-transform: uppercase;
`;

export const PhotosWrapper = styled.div`
  display: flex;
  margin-left: -16px;
  width: calc(100% + 32px);
  overflow-x: scroll;
  padding: 15px 0;

  ${media.tabletP`
    margin-left: 0;
    width: auto;
    overflow-x: auto;
  `};
`;

export const Circle = styled.div`
  border: 1px solid ${WHITE};
  border-radius: 50%;
  height: 180px;
  min-width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-left: 12px;
  background-color: transparent;

  :last-child {
    margin-right: 12px;
  }
`;

export const ImageContainer = styled.div`
  border-radius: 50%;
  background-image: url(${({ image }) => image});
  height: 90%;
  width: 90%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export const Hero = styled.div`
  width: 100%;
  background-color: ${BG_GRAY.COMMON_1};
  padding: 16px 16px 50px;
`;

export const LastVisit = styled.span`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.1px;
  text-transform: uppercase;

  p {
    font-size: 18px;
    margin: 8px 0;
  }
`;

export const Name = styled.h1`
  font-size: 26px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  text-align: center;
  margin-top: 42px;

  ${media.tabletP`
    font-size: 48px;
    letter-spacing: 0.1px;
    margin-bottom: 25px;
  `};
`;

export const Info = styled.h3`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.17;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 30px;
  text-align: center;
  text-transform: uppercase;

  ${media.tabletP`
    font-size: 18px;
    line-height: 1.5;
  `};
`;

export const TreatmentsListWrapper = styled.div`
  background-color: ${BLACK};
  color: ${WHITE};
  padding: 50px 16px;
  margin-bottom: 70px;

  ${media.tabletL`
    padding: 95px 0;
  `};
`;

export const TreatmentsList = styled.ul`
  list-style: none;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  max-width: ${STYLIST_LOCKUP}px;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 115px;

  a {
    font-size: 14px;
    font-weight: 800;
    text-transform: uppercase;
    text-decoration: underline;
  }
`;
export const EmailButton = styled.button`
  border: none;
  background-color: ${BLACK};
  cursor: pointer;
  color: ${WHITE};
  text-transform: uppercase;
  height: 65px;
  line-height: 65px;
  padding: 0 50px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 800;

  :disabled {
    opacity: 0.3;
  }
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: -5px;
  margin-top: 20px;

  ::after {
    content: ' ';
    display: block;
    width: 15px;
    height: 15px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: spinner 1.2s linear infinite;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/VisitSummaryPage/VisitSummaryPage.style.js